import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { countryReference } from 'src/app/utils/constants/strings';
import { Subscription } from 'rxjs';
import { MotherShipperDetailsComponent } from '../mother-shipper-details/mother-shipper-details.component';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
@Component({
  selector: 'app-mother-shipper-list',
  templateUrl: './mother-shipper-list.component.html',
  styleUrls: ['./mother-shipper-list.component.css'],
})
export class MotherShipperListComponent implements OnInit, AfterViewInit {
  mawbCountryArray = [];
  configData: any;
  MotherShipperResponse;
  motherShipperData: MatTableDataSource<any>;
  babyServiceCodesForAllCountries;
  isLbx;
  displayedColumns: string[] = [
    'nickName',
    'shipperCompanyName',
    'shipperContactPersonName',
    'shipperCountryCode',
    'shipperCountryName',
    'action',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  shipperData;
  destinationList = countryReference;
  serviceSubscription$ = new Subscription();

  constructor(
    private dialog: MatDialog,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {
    this.getWorkflowConfig();
  }

  ngOnInit() {
    this.getMotherShipperList();
  }

  ngAfterViewInit() {
    if (this.motherShipperData) {
      this.motherShipperData.paginator = this.paginator;
    }
  }

  getMotherShipperList() {
    this.configService.fetchConfig('mother_shipperdetails').then(res => {
      this.shipperData = res;
      this.MotherShipperResponse = res.data.filter(
        shipper => shipper.workflow === (this.isLbx === true ? 'lbx' : 'bbx')
      );
      this.motherShipperData = new MatTableDataSource(this.MotherShipperResponse);
      this.motherShipperData.paginator = this.paginator;
    });
  }

  openEditorCreatePopup(value, index, action) {
    if (action === 'Edit') {
      index = this.shipperData.data.findIndex(item => item.addressId === value.addressId);
    }

    const dialogRef = this.dialog.open(MotherShipperDetailsComponent, {
      disableClose: true,
      maxHeight: '100vh',
      maxWidth: '80vw',
      data: {
        mappingData: value,
        labelName: action,
        index: index,
        configData: this.shipperData,
      },
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data == 'true') {
        this.getMotherShipperList();
      }
    });
  }

  getWorkflowConfig() {
    this.configService.fetchConfig('loose_bbx').then(response => {
      const bbxWorkflow = response.data[0];
      this.isLbx = bbxWorkflow === 'Yes' ? true : false;
      if (this.isLbx) {
        this.displayedColumns.splice(this.displayedColumns.length - 1, 0, 'isDefault');
      }
    });
  }

  deleteMotherShipper(element) {
    const dailogData = {
      message: 'alert.deleteMotherShipper',
    };
    const alertDialog = this.dialog.open(AlertComponent, {
      data: dailogData,
    });
    alertDialog.afterClosed().subscribe(res => {
      if (res == 'true') {
        this.deleteShipperAddress(element);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  deleteShipperAddress(element) {
    const indexToRemove = this.shipperData.data.findIndex(
      item => item.addressId === element.addressId
    );

    const filteredData = {
      ...this.shipperData, // Copy the rest of the properties
      data: this.shipperData.data.filter((_, index) => index !== indexToRemove),
    };

    this.saveCountryData(filteredData);
  }

  saveCountryData(config) {
    const configReq: any = {};
    configReq.config_id = 'mother_shipperdetails';
    configReq.data = config.data;
    this.configService.saveMappingOption(configReq).subscribe(res => {
      this.configService.putConfig(configReq.config_id, configReq.data);
      this.getMotherShipperList();
    });
  }
}
